import React from 'react';
import { SaveObjectPanel } from '../../../../../Components/SaveObjectPanel/SaveObjectPanel';
import { ItemListConfig, ItemValueType } from '../../../../../Models';
import { ItemForm } from '../ItemForm/ItemForm';
import {
  ItemListSection,
  ItemListSectionMessage
} from '../ItemListSection/ItemListSection';
import { UserGroup } from 'ui-smartforce-settings';
import { useItemListFormView } from './Hooks/useItemListformView';

export const UserGroupsContext = React.createContext<UserGroup[]>([]);

export interface ItemListFormProps {
  name: string;
  className?: string;
  config: ItemListConfig;
  itemLabel: string;
  itemListValue: ItemValueType[];
  disabled?: boolean;
  message?: ItemListSectionMessage;
  showStateMandated?: boolean;
  onChange: (itemListValue: ItemValueType[], index?: number) => void;
}

export const ItemListForm = ({
  name,
  className,
  config,
  itemLabel,
  itemListValue,
  disabled = false,
  message,
  showStateMandated = false,
  onChange
}: ItemListFormProps): React.ReactElement<ItemListFormProps> => {
  const {
    isPanelOpen,
    value,
    selected,
    groups,
    isSaveDisabled,
    onAdd,
    onSelect,
    onDuplicate,
    onRemove,
    onSave,
    onClosePanel,
    onItemFormChange
  } = useItemListFormView({ config, itemListValue, onChange });

  return (
    <React.Fragment>
      <SaveObjectPanel
        title={`${itemLabel} ${
          selected === -1 ? itemListValue.length + 1 : selected + 1
        }`}
        isOpen={isPanelOpen}
        isSaveDisabled={isSaveDisabled}
        saveBtnLabel={selected !== -1 ? 'Save Changes' : `Add ${itemLabel}`}
        onClose={onClosePanel}
        onSave={onSave}
      >
        <UserGroupsContext.Provider value={groups}>
          <ItemForm
            sectionName={name}
            config={config}
            value={value}
            onChange={onItemFormChange}
          />
        </UserGroupsContext.Provider>
      </SaveObjectPanel>

      <ItemListSection
        className={className}
        title={config.title}
        items={itemListValue}
        config={config}
        itemLabel={itemLabel}
        onAdd={onAdd}
        onSelect={onSelect}
        onDuplicate={onDuplicate}
        onRemove={onRemove}
        disabled={disabled}
        message={message}
        showStateMandated={showStateMandated}
      />
    </React.Fragment>
  );
};
